import { useMutation } from "@tanstack/react-query";
import api from "../../../api";
import { toast } from "react-toastify";
import { toastStyles } from "../../../styles/styles";
import { PAGE_CONFIG } from "../config";

export const useDeleteConstitution = (queryClient, theme, onSuccessCallback) => {

    const { mutate: deleteConstitution, status: deleteStatus, isPending: isDeleting } = useMutation({
        mutationFn: (id) => api.constitutions.deleteConstitution(id),
        onSuccess: (data) => {
            toast.success(data?.message || 'Constitution deleted successfully', { ...toastStyles, theme: theme });
            queryClient.invalidateQueries([PAGE_CONFIG.GET_QUERY_KEY]);
            onSuccessCallback && onSuccessCallback();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || 'Constitution deletion failed', { ...toastStyles, theme: theme });
        }
    });

    return { deleteConstitution, isDeleting, deleteStatus };
}